import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { IJudgeSpecialityDTO, JudgeSpecialityDTO } from './judge.specialty.dto';
import { IRubricDTO, RubricDTO } from './rubric.dto';
import { IRubricFieldDTO, RubricFieldDTO } from './rubric.field.dto';

export interface IRubricSectionDTO extends IBaseEntityDTO {
  name: string;
  order: number;
  fields: IRubricFieldDTO[];
  rubric: IRubricDTO;
  specialities: IJudgeSpecialityDTO[];
}

export class RubricSectionDTO extends BaseEntityDTO implements IRubricSectionDTO {
  name: string;
  order: number;
  fields: IRubricFieldDTO[];
  rubric: IRubricDTO;
  specialities: IJudgeSpecialityDTO[];
  constructor(data?: Partial<IRubricSectionDTO>) {
    super(data);
    this.name = data?.name ? data.name : '';
    this.order = data?.order ? data.order : 0;
    this.fields = data?.fields ? data.fields.map((field) => new RubricFieldDTO(field)) : [];
    this.rubric = new RubricDTO(data?.rubric);
    this.specialities = data?.specialities
      ? data.specialities.map((specialty) => new JudgeSpecialityDTO(specialty))
      : [];
  }
}
